module.exports = __webpack_public_path__ + "img/deleted.1723b43c.svg";